<template>
    <div style="height: 100%;">
        <div class="healthRecordBody">
            <el-collapse v-model="activeNames">
                <el-collapse-item :name='0'>
                    <template slot="title">
                        <div style="font-size:20px" class="title"><div class="leftIcon"></div> 既往史</div>
                    </template>
                    <el-collapse v-model="activeNames1">
                        <el-collapse-item :name='0'>
                            <template slot="title">
                                <div class="title"><span>疾病列表</span>
                                    <el-button type="primary" v-show="!disabled" plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('illness')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入疾病名称" v-model="illness.name" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-input  placeholder="请输入诊断医院或社区" v-model="illness.hospital" clearable style="margin-right:10px;width:200px"></el-input>
                                <Daterange :startTime="illness.startTime" :endTime="illness.endTime" identifying='illness' lable='确诊时间' @dataChange='dataChange'></Daterange>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('illness',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="illness.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="illness.loading">
                                    <el-table-column prop="name" label="疾病名称" ></el-table-column>
                                    <el-table-column prop="confirmedTime"  :formatter="getTime" label="确诊时间" ></el-table-column>
                                    <el-table-column prop="hospital" label="诊断医院或社区" ></el-table-column>
                                    <el-table-column prop="illnessStatus" label="现在状态" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                    <el-table-column label="操作" v-if="!disabled"> 
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click="openAddAndEdit('illness',scope.row)">编辑 </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{illness.totalItems}}条（{{Math.ceil(illness.totalItems/illness.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :current-page.sync='illness.pageIndex'
                                        :total="illness.totalItems"
                                        :page-size="20"
                                        @current-change="current_change('illness')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item :name='1'>
                            <template slot="title">
                                <div class="title"><span>手术列表</span>
                                    <el-button type="primary" v-show="!disabled"  plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('operation')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入手术名称" v-model="operation.name" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-input  placeholder="请输入医院名称" v-model="operation.hospital" clearable style="margin-right:10px;width:200px"></el-input>
                                <Daterange :startTime="operation.startTime" :endTime="operation.endTime" identifying='operation'  lable='手术时间' @dataChange='dataChange'></Daterange>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('operation',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="operation.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="operation.loading">
                                    <el-table-column prop="name" label="手术名称" ></el-table-column>
                                    <el-table-column prop="confirmedTime"  :formatter="getTime" label="手术时间" ></el-table-column>
                                    <el-table-column prop="hospital" label="医院名称" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                    <el-table-column label="操作" v-if="!disabled"> 
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click="openAddAndEdit('operation',scope.row)">编辑 </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{operation.totalItems}}条（{{Math.ceil(operation.totalItems/operation.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="operation.totalItems"
                                        :current-page.sync='operation.pageIndex'
                                        :page-size="20"
                                        @current-change="current_change('operation')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item :name='2'>
                            <template slot="title">
                                <div class="title"><span>外伤列表</span>
                                    <el-button type="primary" v-show="!disabled" plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('trauma')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入外伤名称" v-model="trauma.name" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-input  placeholder="请输入医院名称" v-model="trauma.hospital" clearable style="margin-right:10px;width:200px"></el-input>
                                <Daterange :startTime="trauma.startTime" :endTime="trauma.endTime" identifying='trauma'  lable='发生时间' @dataChange='dataChange'></Daterange>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('trauma',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="trauma.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="trauma.loading">
                                    <el-table-column prop="name" label="外伤名称" ></el-table-column>
                                    <el-table-column prop="confirmedTime"  :formatter="getTime" label="发生时间" ></el-table-column>
                                    <el-table-column prop="hospital" label="医院名称" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                    <el-table-column label="操作" v-if="!disabled"> 
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click="openAddAndEdit('trauma',scope.row)">编辑 </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{trauma.totalItems}}条（{{Math.ceil(trauma.totalItems/trauma.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="trauma.totalItems"
                                        :page-size="20"
                                        :current-page.sync='trauma.pageIndex'
                                        @current-change="current_change('trauma')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item :name='3'>
                            <template slot="title">
                                <div class="title"><span>输血列表</span>
                                    <el-button type="primary" v-show="!disabled" plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('transfusion')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入输血原因" v-model="transfusion.reasonInfusion" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-input  placeholder="请输入输血量（cc）" v-model="transfusion.bloodTraVol" clearable style="margin-right:10px;width:200px"></el-input>
                                <Daterange :startTime="transfusion.startTime" :endTime="transfusion.endTime" identifying='transfusion'  lable='发生时间' @dataChange='dataChange'></Daterange>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('transfusion',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="transfusion.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="transfusion.loading">
                                    <el-table-column prop="reasonInfusion" label="输血原因" ></el-table-column>
                                    <el-table-column prop="confirmedTime"  :formatter="getTime" label="发生时间" ></el-table-column>
                                    <el-table-column prop="bloodTraVol" label="输血量（cc）" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                    <el-table-column label="操作" v-if="!disabled">
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click="openAddAndEdit('transfusion',scope.row)">编辑 </el-button>
                                        </template> 
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{transfusion.totalItems}}条（{{Math.ceil(transfusion.totalItems/transfusion.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="transfusion.totalItems"
                                        :page-size="20"
                                        :current-page.sync='transfusion.pageIndex'
                                        @current-change="current_change('transfusion')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
                <el-collapse-item :name='1'>
                    <template slot="title">
                        <div style="font-size:20px" class="title"><div class="leftIcon"></div> 家族史</div>
                    </template>
                    <el-collapse v-model="activeNames2">
                        <el-collapse-item :name='0'>
                            <template slot="title">
                                <div class="title"><span>家族史列表</span>
                                    <el-button type="primary" v-show="!disabled" plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('familyHistory')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入疾病名称" v-model="familyHistory.name" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-select v-model="familyHistory.relation" placeholder="请选择关系" style="margin-right:10px;width:200px">
                                    <el-option
                                        v-for="itemSelect in slectValue(relationValue)"
                                        :key="itemSelect.value"
                                        :label="itemSelect.label"
                                        :value="itemSelect.value">
                                    </el-option>
                                </el-select>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('familyHistory',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="familyHistory.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="familyHistory.loading">
                                    <el-table-column prop="relation" :formatter="getRelation" label="关系" ></el-table-column>
                                    <el-table-column prop="name" label="疾病名称" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                    <el-table-column label="操作" v-if="!disabled"> 
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click="openAddAndEdit('familyHistory',scope.row)">编辑 </el-button>
                                        </template> 
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{familyHistory.totalItems}}条（{{Math.ceil(familyHistory.totalItems/familyHistory.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="familyHistory.totalItems"
                                        :page-size="20"
                                        :current-page.sync='familyHistory.pageIndex'
                                        @current-change="current_change('familyHistory')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
                <el-collapse-item :name='2'>
                    <template slot="title">
                        <div style="font-size:20px" class="title"><div class="leftIcon"></div> 遗传病史</div>
                    </template>
                    <el-collapse v-model="activeNames3">
                        <el-collapse-item :name='0'>
                            <template slot="title">
                                <div class="title"><span>疾病列表</span>
                                    <el-button type="primary" v-show="!disabled" plain style="margin-left:20px;transform: translate(0, -3px);" size="small" icon="el-icon-plus"  v-on:click.stop="openAddAndEdit('geneticDisease')">新增</el-button>
                                </div>
                            </template>
                            <div class="search">
                                <el-input  placeholder="请输入疾病名称" v-model="geneticDisease.name" clearable style="margin-right:10px;width:200px"></el-input>
                                <el-input  placeholder="请输入诊断医院或社区" v-model="geneticDisease.hospital" clearable style="margin-right:10px;width:200px"></el-input>
                                <Daterange :startTime="geneticDisease.startTime" :endTime="geneticDisease.endTime" identifying='geneticDisease' lable='确诊时间' @dataChange='dataChange'></Daterange>
                                <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getListHealth('geneticDisease',true)">搜索</el-button>
                            </div>
                            <div>
                                <el-table :data="geneticDisease.tableData"
                                    :height="400"
                                    border
                                    style="width: 100%;"
                                    v-loading="geneticDisease.loading">
                                    <el-table-column prop="name" label="疾病名称" ></el-table-column>
                                    <el-table-column prop="confirmedTime"  :formatter="getTime" label="确诊时间" ></el-table-column>
                                    <el-table-column prop="hospital" label="诊断医院或社区" ></el-table-column>
                                    <el-table-column prop="illnessStatus" label="现在状态" ></el-table-column>
                                    <el-table-column prop="remarks" label="备注" ></el-table-column>
                                </el-table>
                            </div>
                            <div style="text-align: left;background-color: #fff;padding: 10px;">
                                <div style="float: left;padding: 5px;">共{{geneticDisease.totalItems}}条（{{Math.ceil(geneticDisease.totalItems/geneticDisease.pageSize)}}页）
                                </div>
                                <div style="float: left;">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="geneticDisease.totalItems"
                                        :page-size="20"
                                        :current-page.sync='geneticDisease.pageIndex'
                                        @current-change="current_change('geneticDisease')">
                                    </el-pagination>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Daterange from "@/components/Daterange";
    export default {
        name: "Role",
        data(){
            return{
                activeNames:[0,1,2],
                activeNames1:[0,1,2,3],
                activeNames2:[0],
                activeNames3:[0],
                showModalHealthRecordAdd:false,
                disabled:false,
                nameValue:[],
                hospital:[],
                elderlyData:'',
                illness:{
                    name:'',
                    hospital:'',
                    startTime:'',
                    endTime:'',
                    isTime:'true',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:1
                },
                operation:{
                    name:'',
                    hospital:'',
                    startTime:'',
                    endTime:'',
                    isTime:'true',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:2
                },
                trauma:{
                    name:'',
                    hospital:'',
                    startTime:'',
                    endTime:'',
                    isTime:'true',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:3
                },
                transfusion:{
                    bloodTraVol:'',
                    reasonInfusion:'',
                    startTime:'',
                    endTime:'',
                    isTime:'true',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:4
                },
                familyHistory:{
                    name:'',
                    relation:'',
                    startTime:'',
                    endTime:'',
                    isTime:'',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:5
                },
                geneticDisease:{
                    name:'',
                    hospital:'',
                    startTime:'',
                    endTime:'',
                    isTime:'true',
                    tableData:[],
                    loading:false,
                    totalItems:0,
                    pageSize:20,
                    pageIndex:1,
                    status:6
                },
                relationValue:['祖孙','父子','母子','父女','母女','姐弟','姐妹','兄弟','兄妹','姑侄','叔侄','舅甥','姨甥','婆媳','女婿','其它'],
                healthObj:{
                    illness:1,
                    operation:2,
                    trauma:3,
                    transfusion:4,
                    familyHistory:5,
                    geneticDisease:6,
                },
                //搜索模板
                searchInfo:{
                    name:'',
                    hospital:'',
                    bloodTraVol:'',
                    reasonInfusion:'',
                    relation:'',
                    status:'',
                    isTime:'',
                    startTime:'',
                    endTime:'',
                    pageIndex:'',
                    pageSize:'',
                    elderlyCode:''
                }
            }
        },
        created(){
            
        },
        components:{Daterange,
        
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(){
            },
        },
        methods:{
            init(flag,row,disabled) {
                if(disabled)this.disabled=disabled
                this.elderlyData=row
                const time=new Date()
                var endTime=timefilters(time).slice(0,10)
                var startTime=timefilters(time.setFullYear(time.getFullYear()-3)).slice(0,10)
                for(var i in this.healthObj){
                    if(this[i].endTime!=undefined){
                        this[i].endTime=endTime
                        this[i].startTime=startTime
                    }
                    this[i].pageIndex=1
                    if(this[i].name!=undefined)this[i].name=''
                    if(this[i].hospital!=undefined)this[i].hospital=''
                    if(this[i].bloodTraVol!=undefined)this[i].bloodTraVol=''
                    if(this[i].reasonInfusion!=undefined)this[i].reasonInfusion=''
                    if(this[i].relation!=undefined)this[i].relation=''
                }
                this.getListHealth('illness')
                this.getListHealth('operation')
                this.getListHealth('trauma')
                this.getListHealth('transfusion')
                this.getListHealth('familyHistory')
                this.getListHealth('geneticDisease')
                this.activeNames=[0,1,2]
                this.activeNames1=[0,1,2,3]
                this.activeNames2=[0]
                this.activeNames3=[0]
            },
            closeHealthRecordAdd(){
                this.showModalHealthRecordAdd=false
            },
            openAddAndEdit(index,datas){
                var formDatas=[];
                var data={}
                switch(index){
                    case 'illness':
                        formDatas=[
                            {span:12,name:'疾病名称',value:'name',type:'input'},
                            {span:12,name:'确诊时间',value:'confirmedTime',type:'date'},
                            {span:12,name:'诊断医院或社区',value:'hospital',type:'input'},
                            {span:12,name:'现在状态',value:'illnessStatus',type:'input'},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                    case 'operation':
                        formDatas=[
                            {span:12,name:'手术名称',value:'name',type:'input'},
                            {span:12,name:'手术时间',value:'confirmedTime',type:'date'},
                            {span:12,name:'医院名称',value:'hospital',type:'input'},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                    case 'trauma':
                        formDatas=[
                            {span:12,name:'外伤名称',value:'name',type:'input'},
                            {span:12,name:'发生时间',value:'confirmedTime',type:'date'},
                            {span:12,name:'医院名称',value:'hospital',type:'input'},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                    case 'transfusion':
                        formDatas=[
                            {span:12,name:'输血原因',value:'reasonInfusion',type:'input'},
                            {span:12,name:'发生时间',value:'confirmedTime',type:'date'},
                            {span:12,name:'输血量',value:'bloodTraVol',type:'number'},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                    case 'familyHistory':
                        formDatas=[
                            {span:12,name:'疾病名称',value:'name',type:'input'},
                            {span:12,name:'关系',value:'relation',type:'select',options:this.slectValue(this.relationValue)},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                    case 'geneticDisease':
                        formDatas=[
                            {span:12,name:'疾病名称',value:'name',type:'input'},
                            {span:12,name:'确诊时间',value:'confirmedTime',type:'date'},
                            {span:12,name:'诊断医院或社区',value:'hospital',type:'input'},
                            {span:12,name:'现在状态',value:'illnessStatus',type:'input'},
                            {span:24,name:'备注',value:'remarks',type:'textarea'}];
                        break;
                }
                data={ elderlyCode:this.elderlyData.elderlyCode,status:this[index].status,type:index}
                this.$refs.myHealthRecordAdd.init(formDatas,data,datas);
                this.showModalHealthRecordAdd=true
            },
            getRelation(row,index,cloum){
                return this.relationValue[cloum-1]
            },
            slectValue(list){
                var lists=[]
                for(var i in list){
                    var list1={}
                    list1.value=parseInt(i)+1
                    list1.label=list[i]
                    lists.push(list1)
                }
                return lists;
            },
            dataChange(val,identifying){
                this[identifying].startTime=val[0]
                this[identifying].endTime=val[1]
            },
            getTime(row,index,cloum){
                return timefilters(cloum).slice(0,10)
            },
            current_change: function (index) {
                this.getListHealth(index)
            },
            getListHealth(index,isInit){
                if(isInit)this[index].pageIndex=1
                var data=JSON.stringify(this.searchInfo)
                data=JSON.parse(data)
                for(var i in data){
                    this[index][i]?data[i]=this[index][i]:data[i]=''
                }
                data.elderlyCode=this.elderlyData.elderlyCode
                this.getAxios(data).then(resolve=>{
                    this[index].tableData=resolve.list
                    this[index].totalItems = resolve.total;
                })
            },
            getAxios(data){
                var datas={
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                }
                Object.assign(datas, data);
                return new Promise((resolve, reject) => {
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"EHealthRecord/Page",
                        data:datas
                    }).then( (response)=> {
                        if(response.data.error == 0){
                            resolve(response.data.data);
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }).catch(function (error) {
                        reject(error.data)
                    });
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .healthRecordBody{
        padding: 0 20px;
        .title{
            font-size: 18px;
            font-weight: bold;
            .leftIcon{
                width: 6px;
                height: 25px;
                margin-right: 5px;
                transform: translate(0,5px);
                display: inline-block;
                background: #5d88e8;
            }
        }
        .search{
            border-top:1px solid #eee;
            padding: 10px 0;
        }
    }
</style>
